import { render } from "./Layout.vue?vue&type=template&id=6dd55c60&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=6dd55c60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6dd55c60"

export default script